import { useTranslation } from "react-i18next";
import { Box, IconButton, Tab, Tabs, Typography } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { ArrowBackButtonIcon } from "../../../assets/icons/entity-icons";
import { getEntityProfileRoute } from "../../../../../routers/routeUtils";

const TABS = ["general-info", "achievements", "locations"] as const;
type TabType = (typeof TABS)[number];

const TabsNavigation = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "entityProfileEdit" });

  const navigate = useNavigate();
  const location = useLocation();
  const { entityId } = useParams<{ entityId: string }>();

  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get("tab") || "general-info";

  const handleTabChange = (event: React.SyntheticEvent, newValue: TabType) => {
    const searchParams = new URLSearchParams(location.search);
    Array.from(searchParams.keys()).forEach((key) => {
      searchParams.delete(key);
    });
    searchParams.set("tab", newValue);

    navigate({ search: searchParams.toString() });
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.header}>
        <IconButton onClick={() => navigate(getEntityProfileRoute(Number(entityId)))}>
          <ArrowBackButtonIcon />
        </IconButton>
        <Typography sx={styles.title}>{t("entityProfileEdit")}</Typography>
      </Box>
      <Tabs
        value={currentTab}
        onChange={handleTabChange}
        aria-label="profile tabs"
        sx={styles.tabs}
        variant="scrollable"
        scrollButtons="auto"
      >
        {TABS.map((tab) => (
          <Tab key={tab} label={t(tab)} value={tab} sx={styles.tabStyle} />
        ))}
      </Tabs>
    </Box>
  );
};

export default TabsNavigation;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "32px",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "var(--White, #FFF)",
    padding: "20px 20px 0",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 800,
    lineHeight: "normal",
  },
  tabs: {
    minHeight: "fit-content",
    "& .MuiTabs-flexContainer": {
      gap: "24px",
    },
  },
  tabStyle: {
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    padding: "0px 4px 12px 4px",
    textTransform: "none",
    minHeight: "fit-content",
    minWidth: "fit-content",
    "&.Mui-selected": {
      color: "var(--Brand-700, #076D0D)",
    },
  },
};
